// extracted by mini-css-extract-plugin
module.exports = {"Agenda":"agenda_Agenda__12teU","Date":"agenda_Date__3x32T"};